import type * as React from 'react';
import type { FeedbackResponseDto } from '../../../../../../types/FeedbackResponseDto';
import EntityPreview from '../../../../components/PopupAlert/EntityPreview/index';
import PopupAlertContent from '../../../../components/PopupAlert/PopupAlertContent';
import { FeedbackSingleIcon } from '../../../../components/PopupAlert/icons/index';
import { friendlyList } from '../../../../components/VisibilityIndicator/service';

export const ShareAlert: React.FC<{ response: FeedbackResponseDto }> = ({ response }) => (
    <PopupAlertContent title="Feedback Completed" icon={<FeedbackSingleIcon />}>
        <EntityPreview
            title={response.topic}
            subtitle={`For ${friendlyList(
                2,
                response.reviewees.map(user => user.name)
            )}`}
        />
    </PopupAlertContent>
);
